import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import { RadioInput } from "./RadioInput";

var RadioControl = function RadioControl(_ref) {
  var defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      name = _ref.name,
      options = _ref.options,
      value = _ref.value,
      firstElementRef = _ref.firstElementRef;
  var getClassName = getClassNameFactory(RadioControl.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, options.map(function (option, index) {
    var props = {};
    var onChange = option.onChange,
        label = option.label; // eslint-disable-next-line

    if (value != null) {
      // Controlled mode
      props.checked = option.value === value;
    } // eslint-disable-next-line


    if (defaultValue != null) {
      // Uncontrolled mode
      props.defaultChecked = option.value === defaultValue;
    }

    return /*#__PURE__*/React.createElement(RadioInput, _extends({
      onChange: onChange,
      disabled: disabled,
      value: option.value,
      label: label,
      name: name,
      key: option.value,
      ref: index === 0 ? firstElementRef : null
    }, props));
  }));
};

RadioControl.displayName = "Form.RadioControl";
export default RadioControl;